import { takeLatest, call, put } from "redux-saga/effects";
import { ENGINEERS_PAGE_LOAD, engineersLoaded } from "../../actions/engineers";
import listEngineers from "../../../../../backend/oncall/partners/engineers/list";
import { showErrorPage } from "../../../../../actions/ui/location";

const engineersPageLoadSaga = function*(action) {
  try {
    const result = yield call(listEngineers);
    yield put(engineersLoaded(result.engineers));
  } catch (ignore) {
    yield put(showErrorPage());
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(ENGINEERS_PAGE_LOAD, engineersPageLoadSaga);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/engineers/list-page-load.js